module.exports = __webpack_public_path__ + "static/img/icon_jgc.eabc488c.png";